const doc = [({"en":({"js":({"admin":({"steps":({"table":({"view_step":"View step", "the_step_was_deleted":"The step was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;